import parseHTML from '../../../../Assets/helpers/dom/parseHTML.js';
import rejectNonOkResponse from '../../../../Assets/scripts/rejectNonOkResponse.js';
import './index.scss';

export default class AsyncContent extends HTMLElement {
  static get observedAttributes() {
    return ['content', 'error-url', 'reload'];
  }

  constructor() {
    super();

    this.loaded = false;
    this.reload = false;
    this.errorUrl = null;
    this.loader =
      '<div class="f-asynccontent__loader" role="status" aria-live="polite" aria-label="Chargement en cours"></div>';

    new IntersectionObserver(([{ isIntersecting }]) => isIntersecting && this.loadContent()).observe(this);
  }

  attributeChangedCallback(name, oldValue, value) {
    if (oldValue === value || value === null) {
      return;
    }

    if (name === 'content') {
      this.url = value;

      if (this.loaded) {
        this.loadContent(true);
      }
    }

    if (name === 'error-url') {
      this.errorUrl = value;
    }

    if (name === 'reload') {
      this.reload = value !== 'false';
    }
  }

  async loadContent(isUpdate) {
    if (!this.reload && this.loaded && !isUpdate) {
      return;
    }
    try {
      this.innerHTML = this.loader;

      const html = await (await rejectNonOkResponse(fetch(this.url, { credentials: 'include' }))).text();
      const els = parseHTML(html);
      const links = Array.from(els.querySelectorAll('link[rel="stylesheet"]'));

      await Promise.all(
        links.map(
          (link) =>
            new Promise((resolve, reject) => {
              link.addEventListener('load', () => resolve(link));
              link.addEventListener('error', (e) => reject(e));

              document.head.appendChild(link);
            })
        )
      );

      this.innerHTML = '';
      for (const link of links) {
        this.appendChild(link);
      }
      this.append(els);
      this.loaded = true;
    } catch {
      if (this.errorUrl) {
        document.location.href = this.errorUrl;
      } else {
        this.innerHTML = '<p role="alert">Erreur de chargement</p>';
      }
    }
  }
}

customElements.get('f-asynccontent') || customElements.define('f-asynccontent', AsyncContent);
